import { useEffect } from 'react';
import ScaffoldPage from '../_ScaffoldPage';
export default function InsiderIntelligencePage() {
  useEffect(() => { document.title = 'Insider Intelligence — Track 500+ Form 4 SEC Filings | Nuvport OS'; }, []);
  return <ScaffoldPage badge="INSIDER INTELLIGENCE" title="Follow the money. See what insiders are buying and selling." description="Track 500+ Form 4 SEC filings. Follow CEO purchases, director sells, and hedge fund trades — the same data institutional investors use." canonical="/features/insider-intelligence" />;
}
